/* eslint-disable no-console */
import constants from "../constants";

const { UPDATE_CLIENTS_STORE, UPSERT_CLIENT_STORE, REMOVE_CLIENT_STORE } = constants;

const initialState = {};

export default (state = initialState, action) => {
  if (!action) return state;

  const { type } = action;

  switch (type) {
    case UPDATE_CLIENTS_STORE:
      return { ...(action.data || {}) };

    case UPSERT_CLIENT_STORE: {
      const client = action?.data;
      const uid = client?.uid;
      if (!uid) return state;
      return { ...state, [uid]: client };
    }

    case REMOVE_CLIENT_STORE: {
      const uid = action?.removedId;
      if (!uid) return state;

      const next = { ...state };

      delete next[uid];

      return next;
    }

    default:
      return state;
  }
};
